module.exports = __webpack_public_path__ + "img/5.cc69a921.jpg";